import { API_BASE } from "./common.const";

export const AUTH_SESSION_REFRESH_PATH = "/auth/session/refresh";

export const RoutesApiConst = {
  profile: {
    fetch: `${API_BASE}/profile`,
    update: `${API_BASE}/profile`,
  },
  auth: {
    loginParams: `${API_BASE}/auth/login-params`,
    login: `${API_BASE}/auth/login`,
    loginMS: `${API_BASE}/auth/login-microsoft`,
    loginSaml: `${API_BASE}/auth/login-saml`,
    loginGoogle: `${API_BASE}/auth/login-google`,
    requestOtp: `${API_BASE}/auth/request_otp`,
    loginOtp: `${API_BASE}/auth/login_otp`,
    forgotPassword: `${API_BASE}/auth/forgot-password`,
    resetPassword: `${API_BASE}/auth/reset-password`,
    refresh: `${API_BASE}/auth/refresh`,
    refreshBothTokens: `${API_BASE}/auth/refreshTokens`,
    hybridModeRefresh: `${API_BASE}/auth/hybrid-mode-refresh`,
    logout: `${API_BASE}/auth/logout`,
    sessionLogin: `${API_BASE}/auth/session/login`,
    sessionLoginMS: `${API_BASE}/auth/session/login-microsoft`,
    sessionLoginOtp: `${API_BASE}/auth/session/login-otp`,
    sessionRefresh: `${API_BASE}${AUTH_SESSION_REFRESH_PATH}`,
    sessionLogout: `${API_BASE}/auth/session/logout`,
    sessionMe: `${API_BASE}/auth/session/me`,
    sessionRefreshTtlInfo: `${API_BASE}/auth/session/refresh-ttl-info`,
    sessionBootstrap: `${API_BASE}/auth/session/bootstrap-from-access-token`,
    mfaVerify: `${API_BASE}/auth/mfa/verify`,
    mfaResend: `${API_BASE}/auth/mfa/resend`,
  },
  oauth: {
    /** RFC 9728 document, served at core-api's origin root rather than under API_BASE. */
    protectedResourceMetadata: "/.well-known/oauth-protected-resource",
    consentRequest: (requestId: string): string =>
      `${API_BASE}/oauth/request/${requestId}`,
    consentApprove: (requestId: string): string =>
      `${API_BASE}/oauth/request/${requestId}/approve`,
    consentDeny: (requestId: string): string =>
      `${API_BASE}/oauth/request/${requestId}/deny`,
    grants: (companyId: number): string =>
      `${API_BASE}/c/${companyId}/oauth/grants`,
    grant: (companyId: number, grantId: string): string =>
      `${API_BASE}/c/${companyId}/oauth/grants/${grantId}`,
    connectorAction: (actionId: string): string =>
      `${API_BASE}/oauth/connector-actions/${actionId}`,
    connectorActionApprove: (actionId: string): string =>
      `${API_BASE}/oauth/connector-actions/${actionId}/approve`,
    connectorActionDeny: (actionId: string): string =>
      `${API_BASE}/oauth/connector-actions/${actionId}/deny`,
  },
  views: `${API_BASE}/views`,
};
